import Image from '@atoms/Image/Image';
import Tag from '@atoms/Tag/Tag';
import TagTypesEnum from '@models/enums/TagTypesEnum';
import { ISearchResult } from '@models/ISearchResult';

const SearchResultsCard = ({
  isProduct,
  pageTypeLabel,
  thumbnail,
  title,
  url,
}: ISearchResult) => (
  <div>
    <div>
      <div className="relative h-full w-full">
        {pageTypeLabel && (
          <Tag
            tagType={TagTypesEnum.Secondary}
            className="absolute left-5 top-5 z-[11]"
          >
            {pageTypeLabel}
          </Tag>
        )}

        {url ? (
          <a href={url} className="relative z-10">
            {thumbnail && (
              <Image
                imageClasses="w-full h-full object-cover relative left-0 z-10 aspect-video"
                image={thumbnail}
                sizes="(max-width: 768px) 376px, 500px"
              />
            )}
          </a>
        ) : (
          <div className="relative z-10">
            {thumbnail && (
              <Image
                imageClasses="w-full h-full object-cover relative left-0 z-10 aspect-video"
                image={thumbnail}
                sizes="(max-width: 768px) 376px, 500px"
              />
            )}
          </div>
        )}

        {isProduct && (
          <div className="absolute bottom-0 left-0 right-0 top-0 z-0 aspect-video bg-grey-200" />
        )}
      </div>
    </div>

    {title && (
      <div className="flex flex-col gap-2 px-0 pt-2.5 lg:px-4 lg:pt-7">
        <p className="h5 mb-3 font-light tracking-tight">{title}</p>
      </div>
    )}
  </div>
);

export default SearchResultsCard;
